import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

export default function YieldCalculator() {
  const [streams, setStreams] = useState({
    cohort: 480,
    prediction: 520,
    bundles: 240,
  });
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const sum = streams.cohort + streams.prediction + streams.bundles;
    const duration = 1500;
    const steps = 40;
    const increment = sum / steps;
    let current = 0;
    const timer = setInterval(() => {
      current += increment;
      if (current >= sum) {
        setTotal(sum);
        clearInterval(timer);
      } else {
        setTotal(Math.floor(current));
      }
    }, duration / steps);
    return () => clearInterval(timer);
  }, [streams]);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      className="bg-zinc-900/50 border border-amber-500/30 rounded-lg p-6 box-glow-amber"
    >
      <div className="text-[10px] font-mono tracking-widest text-amber-400 uppercase mb-2">
        Projected Monthly Yield
      </div>
      <div className="flex items-baseline gap-1 mb-6">
        <span className="text-4xl md:text-5xl font-black text-amber-400 text-glow-amber font-mono">
          ${total.toLocaleString()}
        </span>
        <span className="text-sm text-zinc-500 font-mono">/month</span>
      </div>

      <div className="space-y-3 mb-4">
        <div className="flex items-center justify-between text-xs">
          <span className="text-zinc-400">Cohort Queries</span>
          <span className="text-cyan-400 font-mono">${streams.cohort}</span>
        </div>
        <div className="h-1 bg-zinc-950 rounded-full overflow-hidden">
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: '38%' }}
            transition={{ duration: 1, delay: 0.2 }}
            className="h-full bg-cyan-500"
          />
        </div>

        <div className="flex items-center justify-between text-xs">
          <span className="text-zinc-400">Prediction Market</span>
          <span className="text-fuchsia-400 font-mono">${streams.prediction}</span>
        </div>
        <div className="h-1 bg-zinc-950 rounded-full overflow-hidden">
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: '42%' }}
            transition={{ duration: 1, delay: 0.4 }}
            className="h-full bg-fuchsia-500"
          />
        </div>

        <div className="flex items-center justify-between text-xs">
          <span className="text-zinc-400">Training Bundles</span>
          <span className="text-emerald-400 font-mono">${streams.bundles}</span>
        </div>
        <div className="h-1 bg-zinc-950 rounded-full overflow-hidden">
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: '20%' }}
            transition={{ duration: 1, delay: 0.6 }}
            className="h-full bg-emerald-500"
          />
        </div>
      </div>

      <div className="pt-4 border-t border-zinc-800/50 space-y-1.5 text-[11px]">
        <div className="flex justify-between">
          <span className="text-zinc-600">Cohort queries/month</span>
          <span className="text-zinc-400 font-mono">~50K</span>
        </div>
        <div className="flex justify-between">
          <span className="text-zinc-600">Predictions/month</span>
          <span className="text-zinc-400 font-mono">~20K</span>
        </div>
        <div className="flex justify-between">
          <span className="text-zinc-600">Training data/month</span>
          <span className="text-zinc-400 font-mono">~20GB</span>
        </div>
      </div>
    </motion.div>
  );
}